module.exports = __webpack_public_path__ + "img/icon-sodam-url.7a77fa39.svg";